if($('#js-aboutSlider').length){
	let aboutSlider = new Swiper('#js-aboutSlider', {
		loop: true,
		slidesPerView: "auto",
		spaceBetween: 16,
		speed: 6000,
		allowTouchMove: false,
		autoplay: {
			delay: 0
		},
		breakpoints: {
			1024: {
				speed: 9000,
				spaceBetween: 20,
			},
		},
	});
}

if($('#js-featuresSlider').length){
	let featuresSlider = new Swiper('#js-featuresSlider', {
		loop: true,
		slidesPerView: "auto",
		spaceBetween: 10,
		speed: 9000,
		allowTouchMove: false,
		autoplay: {
			delay: 0
		},
		loopedSlides: 4,
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
				speed: 9000,
			},
		},
	});
}


if($('#js-messageSlider').length){
	let messageSlider = new Swiper('#js-messageSlider', {
		loop: true,
		speed: 500,
		centeredSlides: true,
		slidesPerView: "auto",
		spaceBetween: 31,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			1024: {
				slidesPerView: 2.35,
				spaceBetween: 156,
			},
			1366: {
				slidesPerView: 2.35,
				spaceBetween: 156,
			},
		},
	});
}
